import { AxiosObservable } from '@cbridge-utils/axios-observable';
import { ApiServiceType, BaseService, FILE_UPLOAD_HEADERS, transformBlobResponse, BlobWithHeaders } from '@cbridge-packages/api-base';
import { IApiGetPerformanceMetricsRes } from '@cbridge-packages/api';
import { IApiGetExposureAdjustmentTemplateRes } from '../_interfaces/collector/IApiGetExposureAdjustmentTemplate';
import { IApiImportExposureAdjustmentReq, IApiImportExposureAdjustmentRes } from '../_interfaces/collector/IApiImportExposureAdjustment';
import { IApiGetExposureReq, IApiGetExposureRes } from '../_interfaces/exposure/IApiGetExposure';
import { IApiGetExposureDetailsReq, IApiGetExposureDetailsRes } from '../_interfaces/exposure/IApiGetExposureBySymbol';

export class CollectorApiService extends BaseService {
  constructor() {
    super(ApiServiceType.Collector);
  }

  getExposureAdjustmentTemplate(): AxiosObservable<IApiGetExposureAdjustmentTemplateRes> {
    return this.api.get<BlobWithHeaders>('/exposure/adjustment/example', {
      responseType: 'blob',
      transformResponse: transformBlobResponse,
    });
  }

  importExposureAdjustment(payload: IApiImportExposureAdjustmentReq): AxiosObservable<IApiImportExposureAdjustmentRes> {
    return this.api.post<IApiImportExposureAdjustmentRes>('/exposure/adjustment/import', payload, FILE_UPLOAD_HEADERS);
  }

  /* ~~~ Exposure ~~~   */

  getExposure(payload?: IApiGetExposureReq): AxiosObservable<IApiGetExposureRes> {
    return this.api.get<IApiGetExposureRes>('/exposure/symbols', { params: payload });
  }

  getExposureDetails(
    payload?: IApiGetExposureDetailsReq,
  ): AxiosObservable<IApiGetExposureDetailsRes> {
    return this.api.get<IApiGetExposureDetailsRes>('/exposure/details', { params: payload });
  }

  /* ~~~ Performance Metrics ~~~ */

  getPerformanceMetrics(): AxiosObservable<IApiGetPerformanceMetricsRes> {
    return this.api.get<IApiGetPerformanceMetricsRes>('/dashboards/performance');
  }
}
